import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 500px;
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  background: #ffffff; // Instagram native is white usually, but we do glass
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  overflow: hidden;
  backdrop-filter: blur(10px);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
`;

const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
`;

const Name = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: var(--text-primary);
`;

const Location = styled.div`
  font-size: 11px;
  color: var(--text-muted);
`;

const ContentBox = styled.div`
  width: 100%;
  height: 350px;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Actions = styled.div`
  padding: 15px;
  display: flex;
  gap: 15px;
  color: var(--text-primary);

  svg { width: 24px; height: 24px; cursor: pointer; }
`;

const Likes = styled.div`
  padding: 0 15px;
  font-weight: bold;
  font-size: 13px;
  color: var(--text-primary);
`;

const Caption = styled.div`
  padding: 10px 15px 15px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.4;

  span { font-weight: bold; color: var(--text-primary); margin-right: 8px;}
`;

const InstagramFeedWidget = ({ node }) => {
  const url = node.content?.url || 'https://via.placeholder.com/500x500/1e293b/00A9E0?text=Instagram+Post';
  const username = node.content?.username || 'tef_germany';

  return (
    <Wrapper align={node.style?.desktop?.align}>
      <Header>
        <Avatar src="https://via.placeholder.com/100/1e293b/ffffff?text=IG" />
        <div>
          <Name>{username}</Name>
          <Location>München, Deutschland</Location>
        </div>
      </Header>
      <ContentBox>
        <img src={url} alt="Insta Post" />
      </ContentBox>
      <Actions>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"></path></svg>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
      </Actions>
      <Likes>1.402 „Gefällt mir“-Angaben</Likes>
      <Caption>
        <span>{username}</span> 
        Hier präsentieren wir unser brandneues Setup für die diesjährige Messe. Schaut vorbei und entdeckt die Zukunft der Vernetzung! #5G #Tech #O2Telefónica
      </Caption>
    </Wrapper>
  );
};

registry.register('instagram_feed', {
  label: 'Instagram Post',
  icon: '📸',
  category: 'social',
  defaultContent: { username: 'tef_germany' },
  defaultStyle: { desktop: { align: 'center' } },
  render: InstagramFeedWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Instagram Post', fields: [{name:'content.url', label:'Post Bild URL', type:'text'}, {name:'content.username', label:'Account Name', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
